import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge must know our custom theme names, otherwise it can mistake e.g. `text-ink` (colour)
 * and `text-sm` (size) for the same group and drop one of them.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'bg',
        'bg-raised',
        'surface',
        'surface-2',
        'line',
        'line-strong',
        'ink',
        'ink-muted',
        'ink-faint',
        'paper',
        'paper-2',
        'paper-line',
        'paper-ink',
        'paper-ink-muted',
        'orange',
        'orange-deep',
        'pink',
        'pink-deep',
        'teal',
        'teal-deep',
        'mustard',
        'deck-900',
        'deck-800',
        'deck-700',
        'deck-600',
        'brand-spotify',
        'brand-apple',
        'danger',
        'success',
      ],
      font: ['display', 'marker', 'sans'],
      shadow: ['soft', 'card', 'press', 'lift', 'key'],
    },
  },
});

/** Merge conditional class names and resolve Tailwind conflicts (last one wins). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
